export const FETCH_GOOGLE_LOGIN_URL_REQUEST = 'FETCH_GOOGLE_LOGIN_URL_REQUEST';
export const FETCH_GOOGLE_LOGIN_URL_SUCCESS = 'FETCH_GOOGLE_LOGIN_URL_SUCCESS';
export const FETCH_GOOGLE_LOGIN_URL_FAIL = 'FETCH_GOOGLE_LOGIN_URL_FAIL';

export const FETCH_COMPANY_DETAIL_REQUEST = 'FETCH_COMPANY_DETAIL_REQUEST';
export const FETCH_COMPANY_DETAIL_SUCCESS = 'FETCH_COMPANY_DETAIL_SUCCESS';
export const FETCH_COMPANY_DETAIL_FAIL = 'FETCH_COMPANY_DETAIL_FAIL';